<template>
	<div class="article-box">
		<div class="">
			<div class="white-bg">
				<div class="news-title">
					<span class="weizhi">您现在的位置是：
						<a href="../../index.html">首页</a>&nbsp;>&nbsp;<a href="../index.html">二手市场</a></span>
					<h2> </h2>
				</div>
				<div class="news-text-box">
					<h1 class="news-title-h1">{{ detail.title }}</h1>
					<div class="pic-view-other"><span class="po-date">{{ detail.time }}</span><span class="po-view">
							{{ detail.num }} </span>
					</div>
					<div style="display: flex; justify-content: center; margin-top: 35px;">
						<img :src="require('@/assets/images/'+detail.img)" style="max-width: 500px; max-height: 400px; width: auto; height: auto; object-fit: contain;" />
					</div>
					<div style="margin: 25px 0" class="news-text" v-html="detail.remarks"> </div>
					<div style="font-size: 14px; color: #4f6394">
						{{ detail.linkUser }}
						&nbsp;&nbsp;&nbsp;&nbsp;
						{{ isLogin?detail.linkPhone:" 请登录后查看联系方式" }}
					</div>
					<div class="clear"></div>
				</div>
			</div>
			<div class="clear blank"></div>
		</div>
	</div>
</template>

<script>
	// 引入 json 数据文件
	import data from '../../assets/json/data.json';
	import {
			mapState,
			mapGetters,
			mapMutations,
			mapActions
		} from 'vuex'

	export default {
		name: "Detail",
		data() {
			return {
				// 详情信息
				detail: ''
			}
		},
		computed: {
			...mapState(['isLogin']),
		},
		created() {
			let type = this.$route.query.type;
			let index = this.$route.query.id;

			if (type === 'essc') {
				this.detail = data.phoneList[index];
			} else if (type === 'zsjm') {
				this.detail = data.zsjmList[index];
			} else if (type === 'jypx') {
				this.detail = data.jypxList[index];
			} else if (type === 'dzcp') {
				this.detail = data.dzcpList[index];
			} else if (type === 'esdd') {
				this.detail = data.esddList[index];
			} else if (type === 'bgyp') {
				this.detail = data.bgypList[index];
			}
		}
	}
</script>

<style scoped></style>